import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const PAGE_TITLE = 'RELIGIONE PRONTA™ – Lezioni di Religione pronte per Primaria e Secondaria';
const PAGE_DESCRIPTION = 'Il sistema 6-in-1 per docenti di religione (IRC) e catechisti: programmazione annuale, 12 lezioni minuto per minuto, schede da stampare, verifiche con soluzioni e griglie di valutazione, più 5 bonus. PDF digitale, pagamento unico, garanzia 7 giorni.';
function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'it';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESCRIPTION);
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESCRIPTION);
    setMeta('property', 'og:locale', 'it_IT');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="35ozsypftiwt">
      <div lang="it" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="34nc9ur8j3y7">
        <CountdownBar data-id="element-2" data-mp="3uc9inv5c9kir" />
        <main data-id="element-3" data-mp="3uf5i5nwu4h9b">
          <Hero data-id="element-4" data-mp="d4o09u01u88q" />
          <StatsBar data-id="element-5" data-mp="d57dixer88gf" />
          <Difference data-id="element-6" data-mp="d3cujon1mqez" />
          <Recognize data-id="element-7" data-mp="d3wax0x1p6qw" />
          <WhatsInside data-id="element-8" data-mp="85l3ewu838bu" />
          <InsidePages data-id="element-9" data-mp="851mnjgb6pze" />
          <Bonuses data-id="element-10" data-mp="86w7kxrkyi3h" />
          <HowItWorks data-id="element-11" data-mp="86cm572q1bkp" />
          <Audience data-id="element-12" data-mp="83qdf443gq0w" />
          <Offer data-id="element-13" data-mp="3gkv0fqj99ncr" />
          <Guarantee data-id="element-14" data-mp="3gmfwxlp4rgd9" />
          <Testimonials data-id="element-15" data-mp="3glwapssg65tf" />
          <Faq data-id="element-16" data-mp="3gj1s86szuv2n" />
          <FinalCta data-id="element-17" data-mp="3bmjqzgwvhev2" />
        </main>
        <Footer data-id="element-18" data-mp="3bncso3gz5e6c" />
      </div>
    </MotionConfig>;
}